import { render, staticRenderFns } from "./EvidenciadaSelo.vue?vue&type=template&id=2054ff32&scoped=true"
import script from "./EvidenciadaSelo.vue?vue&type=script&lang=js"
export * from "./EvidenciadaSelo.vue?vue&type=script&lang=js"
import style0 from "./EvidenciadaSelo.vue?vue&type=style&index=0&id=2054ff32&prod&lang=css"
import style1 from "./EvidenciadaSelo.vue?vue&type=style&index=1&id=2054ff32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2054ff32",
  null
  
)

export default component.exports